import EventPool from './EventPool';

export default class EventTarget {
  handlers = new Map();

  pools = new Map();

  constructor(target) {
    this.target = target;
  }

  addHandlers(poolName, eventType, eventHandlers) {
    this.removeTargetHandler(eventType);

    if (!this.pools.has(poolName)) {
      this.pools.set(
        poolName,
        EventPool.createByType(poolName, eventType, eventHandlers)
      );
    } else {
      this.pools.set(
        poolName,
        this.pools.get(poolName).addHandlers(eventType, eventHandlers)
      );
    }

    this.addTargetHandler(eventType);
  }

  hasHandlers() {
    return this.handlers.size > 0;
  }

  removeHandlers(poolName, eventType, eventHandlers) {
    const pool = this.pools.get(poolName);

    if (pool) {
      const newPool = pool.removeHandlers(eventType, eventHandlers);

      if (newPool.hasHandlers()) {
        this.pools.set(poolName, newPool);
      } else {
        this.pools.delete(poolName);
      }

      this.removeTargetHandler(eventType);

      if (this.pools.size > 0) this.addTargetHandler(eventType);
    }
  }

  createEmitter = (eventType, eventPools) => event => {
    eventPools.forEach(pool => {
      pool.dispatchEvent(eventType, event);
    });
  };

  addTargetHandler(eventType) {
    const handler = this.createEmitter(eventType, this.pools);

    this.handlers.set(eventType, handler);
    this.target.addEventListener(eventType, handler);
  }

  removeTargetHandler(eventType) {
    if (this.handlers.has(eventType)) {
      this.target.removeEventListener(eventType, this.handlers.get(eventType));
      this.handlers.delete(eventType);
    }
  }
}
